import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import Grow from '@material-ui/core/Grow';
import Divider from '@material-ui/core/Divider';
import Icon from '@material-ui/core/Icon';
import Popper from '@material-ui/core/Popper';
import Button from '../CustomButtons/Button';
import customDropdownStyle from '../../assets/jss/material-kit-react/components/customDropdownStyle';
class CustomDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = () => {
            this.setState(state => ({ open: !state.open }));
        };
        this.handleClose = param => {
            this.setState({ open: false });
            if (this.props && this.props.onClick) {
                this.props.onClick(param);
            }
        };
        this.handleCloseAway = event => {
            if (this.anchorEl.contains(event.target)) {
                return;
            }
            this.setState({ open: false });
        };
        this.state = {
            open: false,
        };
    }
    render() {
        const { open } = this.state;
        const { classes, buttonText, buttonIcon, dropdownList, buttonProps, dropup, dropdownHeader, caret, hoverColor, left, rtlActive, noLiPadding, } = this.props;
        const caretClasses = classNames({
            [classes.caret]: true,
            [classes.caretActive]: open,
            [classes.caretRTL]: rtlActive,
        });
        const dropdownItem = classNames({
            [classes.dropdownItem]: true,
            [classes[hoverColor + 'Hover']]: true,
            [classes.noLiPadding]: noLiPadding,
            [classes.dropdownItemRTL]: rtlActive,
        });
        let icon = null;
        switch (typeof buttonIcon) {
            case 'function':
                icon = React.createElement(this.props.buttonIcon, { className: classes.buttonIcon });
                break;
            case 'string':
                icon = (React.createElement(Icon, { className: classes.buttonIcon }, this.props.buttonIcon));
                break;
            default:
                icon = null;
                break;
        }
        return (React.createElement("div", null,
            React.createElement("div", null,
                React.createElement(Button, Object.assign({ "aria-label": "Notifications", "aria-owns": open ? 'menu-list' : null, "aria-haspopup": "true" }, buttonProps, { buttonRef: node => {
                        this.anchorEl = node;
                    }, onClick: this.handleClick }),
                    icon,
                    buttonText !== undefined ? buttonText : null,
                    caret ? React.createElement("b", { className: caretClasses }) : null)),
            React.createElement(Popper, { open: open, anchorEl: this.anchorEl, transition: true, disablePortal: true, placement: dropup
                    ? left
                        ? 'top-start'
                        : 'top'
                    : left
                        ? 'bottom-start'
                        : 'bottom', className: classNames({
                    [classes.popperClose]: !open,
                    [classes.popperResponsive]: true,
                }) }, () => (React.createElement(Grow, { in: open, id: "menu-list", style: dropup
                    ? { transformOrigin: '0 100% 0' }
                    : { transformOrigin: '0 0 0' } },
                React.createElement(Paper, { className: classes.dropdown },
                    React.createElement(ClickAwayListener, { onClickAway: this.handleCloseAway },
                        React.createElement(MenuList, { role: "menu", className: classes.menuList },
                            dropdownHeader !== undefined ? (React.createElement(MenuItem, { onClick: () => this.handleClose(dropdownHeader), className: classes.dropdownHeader }, dropdownHeader)) : null,
                            dropdownList.map((prop, key) => {
                                if (prop.divider) {
                                    return (React.createElement(Divider, { key: key, onClick: () => this.handleClose('divider'), className: classes.dropdownDividerItem }));
                                }
                                return (React.createElement(MenuItem, { key: key, onClick: () => this.handleClose(prop), className: dropdownItem }, prop));
                            })))))))));
    }
}
CustomDropdown.defaultProps = {
    caret: true,
    hoverColor: 'primary',
};
CustomDropdown.propTypes = {
    classes: PropTypes.object.isRequired,
    hoverColor: PropTypes.oneOf([
        'black',
        'primary',
        'info',
        'success',
        'warning',
        'danger',
        'rose',
    ]),
    buttonText: PropTypes.node,
    buttonIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    dropdownList: PropTypes.array,
    buttonProps: PropTypes.object,
    dropup: PropTypes.bool,
    dropdownHeader: PropTypes.node,
    rtlActive: PropTypes.bool,
    caret: PropTypes.bool,
    left: PropTypes.bool,
    noLiPadding: PropTypes.bool,
    onClick: PropTypes.func,
};
export default withStyles(customDropdownStyle)(CustomDropdown);
//# sourceMappingURL=CustomDropdown.js.map